/**
 *    Countdown
 */

(function ($) {
  Drupal.behaviors.countdown = {
    attach() {
      $('.countdown').each((index, element) => {
        const $this = $(element);
        const $items = $this.find('.countdown__items');
        const $days = $this.find('.countdown__value--days');
        const $hours = $this.find('.countdown__value--hours');
        const $minutes = $this.find('.countdown__value--minutes');
        const $seconds = $this.find('.countdown__value--seconds');
        const countDownDate = new Date($items.data('date')).getTime();

        // Run countdown every second
        setInterval(() => {
          const now = new Date().getTime();
          const timeleft = countDownDate - now;

          // Calculating the days, hours, minutes and seconds left
          const days = Math.floor(timeleft / (1000 * 60 * 60 * 24));
          const hours = Math.floor((timeleft % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
          const minutes = Math.floor((timeleft % (1000 * 60 * 60)) / (1000 * 60));
          const seconds = Math.floor((timeleft % (1000 * 60)) / 1000);

          // Result is output to the specific element
          $days.text(days.toString().padStart(2, '0'));
          $hours.text(hours.toString().padStart(2, '0'));
          $minutes.text(minutes.toString().padStart(2, '0'));
          $seconds.text(seconds.toString().padStart(2, '0'));
        }, 1000);
      });
    },
  };
}(jQuery));

// end of countdown.js
